import { TextField } from "@mui/material";
import * as Sentry from "@sentry/react";
import { useRouter } from "@tanstack/react-router";
import { Controller, useForm } from "react-hook-form";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { accessTokenStorage, refreshTokenStorage } from "@/utils/tokens";

export const LogInForm = () => {
  const intl = useIntl();

  const { invalidate } = useRouter();

  const { control, handleSubmit, formState } = useForm<{
    accessToken: string;
    refreshToken: string;
  }>({
    defaultValues: { accessToken: "", refreshToken: "" },
  });

  return (
    <form
      onSubmit={handleSubmit(async ({ accessToken, refreshToken }) => {
        try {
          accessTokenStorage.set(accessToken);
          refreshTokenStorage.set(refreshToken);

          await invalidate();
        } catch (error) {
          Sentry.captureException(error);
        }
      })}
      noValidate
      className="flex w-full flex-col items-center gap-2"
    >
      <Controller
        control={control}
        rules={{ required: true }}
        name="accessToken"
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            autoFocus
            type="text"
            label={intl.formatMessage({ id: "welcome.accessToken" })}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            autoComplete="off"
          />
        )}
      />
      <Controller
        control={control}
        rules={{ required: true }}
        name="refreshToken"
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            type="text"
            label={intl.formatMessage({ id: "welcome.refreshToken" })}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            autoComplete="off"
          />
        )}
      />

      <Button
        type="submit"
        loading={formState.isSubmitting}
        variant="contained"
        color="primary"
      >
        {intl.formatMessage({ id: "welcome.button" })}
      </Button>
    </form>
  );
};
